<a class="contact" [ngClass]="isShow ? 'show' : ''" routerLink="/{{routesService.getRouterLink('contact')}}" fragment="webform">
    <span i18n>Kontakt <img src="assets/icons/contact-info.svg"></span>
</a>